import {
  newNotificationReceivedActionTypes,
  notificationReceiveCountActionType,
} from "./notifications/actionTypes";
import {
  conversationUpdateActionTypes,
  messageDeletedActionTypes,
  messageEditedActionTypes,
  messageReceivedActionTypes,
  messageReceivedUnreadCountActionTypes,
  newConversationReceivedActionTypes,
  updateIsMyMessagesReadActionTypes,
} from "./conversations/actionTypes";
import {
  blockedByUserActionTypes,
  unblockedByUserActionTypes,
  updateOnlineStatusActionType,
} from "./authors/actionTypes";
import { csvLinkReceivedActionTypes } from "./statistics/actionTypes";
import { forceSignOutActionType } from "./signOut/actionTypes";
import {
  showNewPostsButtonType,
  updatePurchasedPostTypes,
} from "./posts/actionTypes";
import { getProfileActionTypes } from "./profile/actionTypes";
import { getNewSignConsentFormsCountActionTypes } from "./consentForms/actionTypes";
import {
  getNewMessageActionTypes,
  getNewTipActionTypes,
  getParticipantsUpdateActionTypes,
  getUpdatedLivestreamDetailsActionTypes,
  handleBanParticipantActionTypes,
  handleChangeCoStreamerRoleToViewerActionTypes,
  handleCoStreamerStartsStreamActionTypes,
  handleDeleteAllParticipantMessagesActionTypes,
  handleDeleteMessageActionTypes,
  handleHostAcceptedRequestToCoStreamingActionTypes,
  handleInviteFromStreamerToViewerActionsTypes,
  handleMuteParticipantActionTypes,
  livestreamEndedActionTypes,
  updateSpinTheBottleActionType,
} from "./livestreams/actionTypes";

export const SOCKET_DICTIONARY = {
  "receive:posts:new": showNewPostsButtonType,
  "receive:new:notifications:count": notificationReceiveCountActionType,
  "receive:new:message": messageReceivedActionTypes.request,
  // todo: check if I can attach mark as read request to this event
  "receive:updated:conversation": conversationUpdateActionTypes.request,
  "receive:conversations:unread:count":
    messageReceivedUnreadCountActionTypes.request,
  "receive:new:conversation": newConversationReceivedActionTypes.request,
  "receive:block:users": blockedByUserActionTypes.request,
  "receive:unblock:users": unblockedByUserActionTypes.request,
  "receive:updated:users:is-online": updateOnlineStatusActionType,
  "receive:read:conversation": updateIsMyMessagesReadActionTypes.request,
  "receive:conversations:messages:delete": messageDeletedActionTypes.request,
  "receive:new:notification": newNotificationReceivedActionTypes.request,
  "receive:csv:generated": csvLinkReceivedActionTypes.request,
  "receive:users:deleted": forceSignOutActionType,
  "receive:users:blocked": forceSignOutActionType,
  "receive:conversations:messages:update": messageEditedActionTypes.request,
  "receive:post:purchased": updatePurchasedPostTypes,
  "receive:kyc:updated": getProfileActionTypes.request,
  "receive:consent-forms:for-sign:count":
    getNewSignConsentFormsCountActionTypes.request,
  "receive:conversations:messages:sent": messageReceivedActionTypes.request,
  "receive:streams:new-message": getNewMessageActionTypes.request,
  "receive:streams:new-tip": getNewTipActionTypes.request,
  "receive:streams:info-updated":
    getUpdatedLivestreamDetailsActionTypes.request,
  "receive:streams:participants:updated":
    getParticipantsUpdateActionTypes.request,
  "receive:streams:ended": livestreamEndedActionTypes.request,
  "receive:streams:message:deleted": handleDeleteMessageActionTypes.request,
  "receive:streams:messages:deleted:all":
    handleDeleteAllParticipantMessagesActionTypes.request,
  "receive:streams:participants:ban": handleBanParticipantActionTypes.request,
  "receive:streams:participants:muted":
    handleMuteParticipantActionTypes.request,
  "receive:streams:invite:new":
    handleInviteFromStreamerToViewerActionsTypes.request,
  "receive:streams:invite:accepted":
    handleHostAcceptedRequestToCoStreamingActionTypes.request,
  "receive:streams:games:start": updateSpinTheBottleActionType,
  "receive:streams:games:spin": updateSpinTheBottleActionType,
  "receive:streams:games:turnChange": updateSpinTheBottleActionType,
  "receive:streams:games:close": updateSpinTheBottleActionType,
  "receive:streams:games:reset": updateSpinTheBottleActionType,
  "receive:streams:co-streamer:deleted":
    handleChangeCoStreamerRoleToViewerActionTypes.request,
  "receive:streams:co-streamer:added":
    handleCoStreamerStartsStreamActionTypes.request,
};
